import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const quickCategories = categories.slice(0, 6);
  const moreCategories = categories.slice(6);

  return (
    <footer className="relative bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto">
        {/* Upper Footer */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 px-6 md:px-10 py-16 md:py-20">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold tracking-tight">
                allchinabuy<span className="text-primary-400">.art</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mb-6">
              The #1 community resource for AllChinaBuy Spreadsheet — verified finds, QC guides, and shopping tutorials updated weekly.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 text-white text-xs font-semibold px-5 py-2.5 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Open Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          {/* Quick Categories */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">
              Top Categories
            </h4>
            <ul className="space-y-3">
              {quickCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-white transition-colors flex items-center gap-2 cursor-pointer"
                  >
                    <i className={`${cat.icon} text-xs text-foreground-500`}></i>
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* SEO Articles */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">
              Shopping Guides
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/best-allchinabuy-spreadsheet" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  Complete Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link to="/articles/allchinabuy-top-finds-2026" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  Top 100+ Finds 2026
                </Link>
              </li>
              <li>
                <Link to="/articles/is-allchinabuy-safe" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  Safety &amp; Trust Guide
                </Link>
              </li>
              <li>
                <Link to="/articles/how-to-use-allchinabuy-spreadsheet" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  Beginner Guide
                </Link>
              </li>
              <li>
                <Link to="/articles/allchinabuy-qc-photo-guide" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  QC Photo Guide
                </Link>
              </li>
              <li>
                <Link to="/articles/allchinabuy-shipping-guide" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  Shipping Guide
                </Link>
              </li>
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">
              Resources
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/articles/best-allchinabuy-sneakers" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  Best Sneakers Guide
                </Link>
              </li>
              <li>
                <Link to="/articles/allchinabuy-clothing-haul-guide" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  Clothing Haul Guide
                </Link>
              </li>
              <li>
                <Link to="/articles/allchinabuy-bags-accessories-guide" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  Bags &amp; Accessories
                </Link>
              </li>
              <li>
                <Link to="/articles/allchinabuy-budget-finds" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  Budget Finds
                </Link>
              </li>
              <li>
                <Link to="/about/" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-primary-400 hover:text-primary-300 transition-colors font-medium cursor-pointer"
                >
                  AllChinaBuy Spreadsheet
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-foreground-800 px-6 md:px-10 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} allchinabuy.art — All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/privacy-policy" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/editorial-policy" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">
                Editorial Policy
              </Link>
              <span className="text-xs text-foreground-600">
                Updated June 2026
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}